import { Show, useRecordContext } from 'react-admin';
import { BridgeShowTopBar } from '../../../helperComponents/BridgeShowTopBar';
import { RunShowHeader } from './components/RunShowHeader';
import { RunShowStats } from './components/RunShowStats';
import { RunError } from './components/RunError';
import { RunDetails } from './components/RunDetails';

const AdsIngestRunsShowBody = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <>
      <BridgeShowTopBar
        backTo="/ads_ingest_runs"
        backLabel="Data Deliveries"
        crumb={`Google Ads Bridge / Data Deliveries / ${record.id}`}
      />
      <RunShowHeader record={record} />
      <RunShowStats record={record} />
      <RunError record={record} />
      <RunDetails record={record} />
    </>
  );
};

export const AdsIngestRunsShow = (props) => {
  return (
    <Show {...props} title=" " actions={false} component="div">
      <AdsIngestRunsShowBody />
    </Show>
  );
};
